import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

export default function Terms() {
  return (
    <div>
      <Header />
      <main style={{ padding: 24 }}>
        <h1>Terms of Service</h1>
        <p>See full terms at /terms.html. This route provides a SPA version.</p>
      </main>
      <Footer />
    </div>
  );
}
